import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import styles from './styles.module.scss';

import { DateLlFormat } from '../../constants/data';
import { CropName } from '../GlobalComponents/index.jsx';

const SidebarFieldHeader = ({ t, title, crop, startDate, endDate }) => {
  const { crops } = useSelector((state) => state.catalog);

  return (
    <>
      {title && <div className={styles.sidebarFieldTitle}>{title}</div>}
      {crop && <CropName t={t} cropId={crop} crops={crops} size={'small'} />}
      <div className={styles.sidebarFieldTextDelimiter}></div>
      {(startDate || endDate) && (
        <time className={styles.sidebarFieldText}>
          {dayjs(startDate).format(DateLlFormat)}
          <span className={styles.sidebarFieldHyphen}> – </span>
          {endDate ? dayjs(endDate).format(DateLlFormat) : t('empty.noDate')}
        </time>
      )}
    </>
  );
};

export default SidebarFieldHeader;
